import { useState } from "react"
import { Button, Form, Modal } from 'react-bootstrap'
import toast from "react-hot-toast"

import LoadingTextSwap from "../../../components/LoadingTextSwap"
import { useUpdateMemberSpacesMutation } from "../../../app/clubsApiSlice"

const UpdateMemberSpaces = ({ existingSpaces, clubId, children }) => {
  const [UpdateMemberSpaces, { isLoading }] = useUpdateMemberSpacesMutation()

  const [show, setShow] = useState(false)
  const [spaces, setSpaces] = useState(Number(existingSpaces))
  const [error, setError] = useState("")

  const handleShow = () => setShow(true)
  const handleClose = ({ updated = false } = {}) => {
    setShow(false)
    setError("")

    if (!updated) setSpaces(Number(existingSpaces))
  }
  const handleChange = (e) => {
    setSpaces(e.target.value)
    setError("")
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (error) return
    if (spaces === "" || spaces < 0) return setError("Please enter a valid number")
    if (Number(spaces) === Number(existingSpaces)) return handleClose()
      
    try {

      await UpdateMemberSpaces({ clubId, spaces: Number(spaces) }).unwrap()

      handleClose({ updated: true })
      toast.success("Member spaces added")

    } catch (error) {
      console.log(error)

      toast.error("Error adding member spaces")
      handleClose()
    }
  }

  return (
    <>
      <div onClick={handleShow}>{children}</div>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header className="border-0 p-0 mb-3">
          <Modal.Title className="fs-5 fw-bold">Update member spaces</Modal.Title>
        </Modal.Header>

        <Modal.Body className="mb-3 p-0">
          <p className="p-0 text-muted fs-7 mb-3">Please provide the total number of member spaces including existing spaces</p>
          <Form>
            <Form.Group className="mb-3">
              <Form.Control
                type="number"
                value={spaces}
                onChange={handleChange}
                isInvalid={error}
                autoFocus
              />
              <Form.Control.Feedback type="invalid" className="fw-semibold">
                <i>{error}</i>
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer className="p-0 border-0">
          <Button disabled={isLoading} className="shadow-sm rounded-3 m-0 fs-7 me-2" variant="dark" onClick={handleSubmit}>
            <LoadingTextSwap isLoading={isLoading}>
              Save
            </LoadingTextSwap>
          </Button>
          <Button disabled={isLoading} className="shadow-btn rounded-3 border-1 m-0 border-light fs-7" variant="" onClick={handleClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default UpdateMemberSpaces